import { render, staticRenderFns } from "./BdSide.vue?vue&type=template&id=04080ed2&scoped=true&"
import script from "./BdSide.vue?vue&type=script&lang=js&"
export * from "./BdSide.vue?vue&type=script&lang=js&"
import style0 from "./BdSide.vue?vue&type=style&index=0&id=04080ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04080ed2",
  null
  
)

export default component.exports